import StyleSheetRW from "core/StyleSheetRW";

const styles = StyleSheetRW.create(() => ({
  display:{display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'center',gap:10},
  displaySecondary:{ fontWeight: '900', fontSize: 26, background: 'none',cursor:'pointer' },
    question:{
        marginTop: 10,
        fontSize: 20,
        fontWeight: "700",
      },
    textField:{
        height: 50,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'flex-start', // Align text at the top-left start
        width: "100%",
        borderRadius: 10,
        paddingHorizontal: 10,
        backgroundColor: "#0000000D",
        marginTop: 3,
        placeholderTextColor: "#333333",
      },
    topBar:{
        textAlign: "center",
        width: "100%",
        fontSize: 36,
        marginTop:20,
        fontWeight: "700",
        color: "#2F4858",
      },
      notApplicable:{
        marginTop: 10,
        fontSize: 20,
        fontWeight: "700",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-start",
      },
      ratingstar: {
        height:20,
        width: 20,
        position: "relative",
      },
      bottomBar:{flexDirection:'row',justifyContent:'space-evenly',alignItems:'center'},
      legendBox:{borderStyle:'solid',height:'auto',padding:'10px 10px',width:'100%',borderRadius:10,backgroundColor:'#F5F9F6'},
      starContainer:{display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'center'},
      starframe: {
        height: (40),
        width: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: (15),
      },
      applicable:{ marginTop:20,paddingHorizontal: 0, height: "40px",display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'flex-start' },
    scroll:{          overflowX: "hidden",
        width: "100%",
        padding: "0px 20px 0px 20px",},
    outer:{ display: "flex", flexDirection: "row", height: "100%" },
    container: {
      flex: 1,
      width: "100%",
      height: "100%",
    },
    heading: {
      fontFamily: "Outfit",
      fontSize: 32,
      fontWeight: "bold",
      color: "#2F4858",
      width: "100%",
      textAlign: "center",
    },
    heading2: {
      fontFamily: "Outfit",
      fontSize: 32,
      fontWeight: "700",
      color: "#2F4858",
      textAlign: "left",
    },
    subheading: {
      fontFamily: "Outfit",
      fontSize: 18,
      fontWeight: "bold",
      color: "#2F4858",
      marginTop: 10,
    },
    form: {
      width: "100%",
      height: "100%",
      marginTop: 20,
    },
    row: {
      justifyContent: "space-between",
      marginBottom: 10,
      gap: 20,
    },
    inputContainer: {
      flex: 1,
      marginRight: 5,
    },
    label: {
      fontFamily: "Outfit",
      fontSize: 14,
      fontWeight: "600",
      lineHeight: 17.64,
      textAlign: "left",
      marginBottom: 5,
      color: "#333333",
    },
    input: {
      height: 50,
      borderRadius: 10,
      paddingHorizontal: 10,
      backgroundColor: "#0000000D",
      marginTop: 3,
      placeholderTextColor: "#333333",
    },
    header: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
    },
    submitButton: {
      backgroundColor: "#2F4858",
      paddingVertical: 10,
      marginTop: 20,
      paddingHorizontal: 20,
      borderRadius: 100,
      marginBottom:20
    },
    submitButtonText: {
      color: "white",
      fontWeight: "300",
      textAlign: "center",
    },
    line: {
      borderBottomWidth: 1,
      borderColor: "#2F4858",
      marginBottom: 10,
    },
  }));
  export default styles;